export default __webpack_public_path__ + "static/media/configr-horizontal.eb954316.svg";